/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_8Inputs */

const en_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom center`)
};

const fr_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`centre inférieur`)
};

const de_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte unten`)
};

const it_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In basso al centro`)
};

const ru_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижний центр`)
};

const es_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte inferior central`)
};

const zh_cn2_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底部中心`)
};

const ja_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下中央`)
};

const hi_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निचला बीच का`)
};

const pt_pt2_live_caption_youtube_region_8 = /** @type {(inputs: Live_Caption_Youtube_Region_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro inferior`)
};

/**
* | output |
* | --- |
* | "Bottom center" |
*
* @param {Live_Caption_Youtube_Region_8Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_8 = /** @type {((inputs?: Live_Caption_Youtube_Region_8Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_8Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_8(inputs)
	if (locale === "de") return de_live_caption_youtube_region_8(inputs)
	if (locale === "it") return it_live_caption_youtube_region_8(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_8(inputs)
	if (locale === "es") return es_live_caption_youtube_region_8(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_8(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_8(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_8(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_8(inputs)
	return en_live_caption_youtube_region_8(inputs)
});